import React from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import { Timeline } from '@mui/icons-material';

const TrialsInput = ({
  dataPoint,
  index,
  goalType,
  trialsMax,
  handleTrialChange,
  handleAddTrial,
  allGoalData,
}) => {
  if (goalType !== 'Trials') {
    return null;
  }

  // Get the measurement unit from the goal data for trials
  const trialsMeasurementUnit =
    allGoalData?.DataCollection?.measurementType?.DataType ||
    allGoalData?.dataCollection?.DataCollection?.measurementType?.DataType ||
    '';

  const preventNumberScroll = (event) => {
    event.preventDefault();
    event.target.blur();
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: 'transparent',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Timeline sx={{ color: '#6b7280', mr: 1, fontSize: 18 }} />
        <Typography
          variant='body1'
          sx={{
            color: '#1f2937',
            fontWeight: 400,
            fontSize: '1rem',
          }}
        >
          Trials
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {dataPoint?.trialsNumber?.map((trial, trialIndex) => (
          <Box
            key={trialIndex}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              p: 1,
            }}
          >
            <Typography
              variant='body2'
              sx={{
                color: '#1f2937',
                fontWeight: 400,
                minWidth: '100px',
              }}
            >
              {`Trial ${trialIndex + 1} value:`}
            </Typography>
            <TextField
              type='number'
              inputProps={{
                'aria-label': `Trial ${trialIndex + 1} value`,
                inputMode: 'numeric',
                onWheel: preventNumberScroll,
              }}
              margin='dense'
              size='small'
              value={trial ? trial : ''}
              sx={{
                width: '80px',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  '&:hover': {
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#6b7280',
                    },
                  },
                  '&.Mui-focused': {
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#6b7280',
                    },
                  },
                },
              }}
              onChange={(e) =>
                handleTrialChange(index, trialIndex, e.target.value)
              }
            />
            <Typography
              variant='body2'
              sx={{
                color: '#1f2937',
                fontWeight: 400,
              }}
            >
              {trialsMeasurementUnit || ''}
            </Typography>
          </Box>
        ))}

        <Button
          variant='outlined'
          sx={{
            color: '#6b7280',
            borderColor: '#d1d5db',
            textTransform: 'capitalize',
            alignSelf: 'flex-start',
            '&:hover': {
              borderColor: '#6b7280',
              backgroundColor: 'rgba(249, 250, 251, 0.5)',
            },
          }}
          onClick={() => handleAddTrial(index)}
          disabled={
            trialsMax !== 'N/A' &&
            dataPoint.trialsNumber.length >= Number(trialsMax)
          }
        >
          + Add Trials{' '}
          {trialsMax !== 'N/A' &&
            `(${dataPoint.trialsNumber.length}/${trialsMax})`}
        </Button>
      </Box>
    </Paper>
  );
};

export default TrialsInput;
